import React from 'react';
import RawTable from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import RawTableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import RawTableHead from '@mui/material/TableHead';
import RawTableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';

export type BasicTableProps = {
  columns: (string | React.ReactNode)[];
  children: React.ReactNode;
};

const BasicTable = ({ columns, children }: BasicTableProps) => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {columns?.map((title, i) => (
              <TableCell key={`${i} ${title}`}>{title}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>{children}</TableBody>
      </Table>
    </TableContainer>
  );
};

export { BasicTable };
export default BasicTable;

const TableRow = styled(RawTableRow)(() => ({
  height: 60,
}));

const Table = styled(RawTable)(() => ({
  margin: '1em auto',
  width: '100%',
}));

const TableHead = styled(RawTableHead)(({ theme }) => ({
  backgroundColor: theme.palette.blue[60],
  whiteSpace: 'nowrap',
}));

const TableCell = styled(RawTableCell)(({ theme }) => ({
  color: `${theme.palette.neutral.white} !important`,
  textAlign: 'center !important' as CanvasTextAlign,
}));
